import React, { useEffect, useState } from 'react'
import LogoInnerImg from "../../images/logo-inner.svg";
import clinicalEnrollImg from '../../images/clinical-enrolled-icon.svg';
import patinetEnrollImg from '../../images/patient-enrolled-icon.svg';
import complianceIconImg from '../../images/compliance-icon.svg';
import calendarIconImg from '../../images/calendar-icon.svg';
import listedPriceImg from '../../images/listed-price-icon.svg';
import Footer from '../Footer';
import { Link } from 'react-router-dom';
import CopayHistoryService from '../../services/CopayHistoryService';
import { toast } from 'react-toastify';
import Loader from '../../common/Loader';
import { CSVLink } from "react-csv";
import moment from 'moment';
import CoPayPatientGenderChart from './CoPayPatientChart/CoPayPatientGenderChart';
import CoPayPatientAgeChart from './CoPayPatientChart/CoPayPatientAgeChart';
import CoPayEnrolledCliniciansChart from './CoPayPatientChart/CoPayEnrolledCliniciansChart';
import CoPayPatientsEnrolledPerClinicianChart from './CoPayPatientChart/CoPayPatientsEnrolledPerClinicianChart';
import CoPayMonthlyTreatmentChart from './CoPayPatientChart/CoPayMonthlyTreatmentChart';
import CoPayDaysDispensingChart from './CoPayPatientChart/CoPayDaysDispensingChart';
import CoPayPharmacyListedPriceChart from './CoPayPatientChart/CoPayPharmacyListedPriceChart';
import CoPayPharmaciesPerPatientChart from './CoPayPatientChart/CoPayPharmaciesPerPatientChart';
import CoPayCliniciansPerPatientChart from './CoPayPatientChart/CoPayCliniciansPerPatientChart';
const CoPayDashboard = () => {
    const [loading, setLoading] = useState(false);
    const [copayData, setCopayData] = useState([]);


    // const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 10; // Change this value to adjust the number of items per page



    useEffect(() => {
        setLoading(true);
        const fetchData = async () => {
            try {
                const copayHistoryWithPatient = await CopayHistoryService.getCopayHistoryWithPatientData();
                if (copayHistoryWithPatient.data.data.length === 0) {
                    toast.success(copayHistoryWithPatient.data.message);
                } else {
                    setCopayData(copayHistoryWithPatient.data.data);
                }

                setLoading(false);
            } catch (error) {
                setLoading(false);
                toast.error(error);
            }
        };

        fetchData();
    }, []);
    // Calculate the current items to display
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = copayData.slice(indexOfFirstItem, indexOfLastItem);

    // Change page
    const paginate = (pageNumber) => setCurrentPage(pageNumber);

    const CsvHeaders = [
        { label: "Patient ID", key: "patientId" },
        { label: "Date Enrolled", key: "DateEnrolled" },
        { label: "Patient DOB", key: "dob" },
        { label: "Patient Gender", key: "gender" },
        { label: "HCP Name", key: "hcpName" },
        { label: "HCP Suburb", key: "hcpSuburb" },
        { label: "HCP State", key: "hcpState" },
        { label: "Pharmacy Name", key: "pharmacyName" },
        { label: "Pharmacy Suburb", key: "pharmacySuburb" },
        { label: "Pharmacy State", key: "pharmacyState" },
        { label: "Invoice ID", key: "invoiceID" },
        { label: "Invoice Date", key: "invoiceDate" },
        { label: "Invoice Amount", key: "invoiceAmount" },
        { label: "Co-Pay Paid", key: "copayPaid" },
    ];

    return (
        <>
            {loading && <Loader />}
            <header className="inner fixed-top">
                <nav className="navbar navbar-expand-lg bg-white">
                    <section className="container">
                        <div className="navigation d-flex align-items-end w-100">
                            <div className="w-50 logo-inner ms-auto">
                                <img src={LogoInnerImg} className="img-fluid" alt="" />
                            </div>
                        </div>
                    </section>
                </nav>
            </header>
            <main className="inner-page">
                <section className="container">
                    <div className="row">
                        <div className="col-sm-12 text-center">
                            <h1 className="text-uppercase">Key Metrics</h1>
                            <div className="spacer-3"></div>
                        </div>
                    </div>
                    <div className="row gx-2 row-gap-3 justify-content-center">
                        <div className="col-md-6 col-lg-4">
                            <div className="bg-secondary rounded-pill d-flex align-items-center justify-content-center h-254">
                                <img src={clinicalEnrollImg} alt="" />
                                <div className="ps-3">
                                    <h2 className="fw-bold fs-40 text-white mb-0 lh-1">500</h2>
                                    <p className="text-white fs-20 fw-bold mb-0 lh-1">clinicians enrolled</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="bg-secondary rounded-pill d-flex align-items-center justify-content-center h-254">
                                <img src={patinetEnrollImg} alt="" />
                                <div className="ps-3">
                                    <h2 className="fw-bold fs-40 text-white mb-0 lh-1">1,125</h2>
                                    <p className="text-white fs-20 fw-bold mb-0 lh-1">patients enrolled</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="bg-secondary rounded-pill d-flex align-items-center justify-content-center h-254">
                                <img src={complianceIconImg} alt="" />
                                <div className="ps-3">
                                    <h2 className="fw-bold fs-40 text-white mb-0 lh-1">60%</h2>
                                    <p className="text-white fs-20 fw-bold mb-0 lh-1">6-month compliance</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="bg-secondary rounded-pill d-flex align-items-center justify-content-center h-254">
                                <img src={calendarIconImg} alt="" />
                                <div className="ps-3">
                                    <h2 className="fw-bold fs-40 text-white mb-0 lh-1">32</h2>
                                    <p className="text-white fs-20 fw-bold mb-0 lh-1"><span className="text-nowrap">days between <br /> dispensing</span></p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-4">
                            <div className="bg-secondary rounded-pill d-flex align-items-center justify-content-center h-254">
                                <img src={listedPriceImg} alt="" />
                                <div className="ps-3">
                                    <h2 className="fw-bold fs-40 text-white mb-0 lh-1">80%</h2>
                                    <p className="text-white fs-20 fw-bold mb-0 lh-1">listed price</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="spacer-8"></div>
                    <div className="row">
                        <CoPayPatientGenderChart />
                        <div className="spacer-3 d-md-none"></div>
                        <CoPayPatientAgeChart />
                    </div>
                    <div className="spacer-3"></div>
                    <div className="row">
                        <CoPayEnrolledCliniciansChart />
                        <div className="spacer-3 d-md-none"></div>
                        <CoPayPatientsEnrolledPerClinicianChart />
                    </div>
                    <div className="spacer-3"></div>
                    <CoPayMonthlyTreatmentChart />
                    <div className="spacer-3"></div>
                    <div className="row">
                        <CoPayDaysDispensingChart/>
                        <div className="spacer-3 d-md-none"></div>
                      <CoPayPharmacyListedPriceChart/>
                    </div>

                    <div className="spacer-3"></div>
                    <div className="row">
                        <CoPayPharmaciesPerPatientChart/>
                        <div className="spacer-3 d-md-none"></div>
                        <CoPayCliniciansPerPatientChart />
                    </div>

                    <div className="spacer-8"></div>

                    <div className="row gx-3 justify-content-between">
                        <div className="width-lg-100">
                            <div className="row">
                                <div className="col-sm-12 text-center">
                                    <h1 className="text-uppercase">Solutionary Health Co-Pay and Private Market Dashboard</h1>
                                </div>
                            </div>
                            <div className="spacer-3"></div>
                            <div className="row">
                                <div className="col-sm-12">
                                    <div className="table-padding">
                                        <table className="table table-bordered text-center table-style-2 text-nowrap">
                                            <thead className="table-primary">
                                                <tr>
                                                    <th className="text-white lh-sm" valign="middle">Patient<br /> ID</th>
                                                    <th className="text-white lh-sm" valign="middle">Date<br /> Enrolled</th>
                                                    <th className="text-white lh-sm" valign="middle">Patient<br /> DOB</th>
                                                    <th className="text-white lh-sm" valign="middle">Patient <br />Gender</th>
                                                    <th className="text-white lh-sm" valign="middle">HCP <br />Name</th>
                                                    <th className="text-white lh-sm" valign="middle">HCP<br /> Suburb</th>
                                                    <th className="text-white lh-sm" valign="middle">HCP<br /> State</th>
                                                    <th className="text-white lh-sm" valign="middle">Pharmacy <br />Name</th>
                                                    <th className="text-white lh-sm" valign="middle">Pharmacy <br />Suburb</th>
                                                    <th className="text-white lh-sm" valign="middle">Pharmacy <br />State</th>
                                                    <th className="text-white lh-sm" valign="middle">Invoice <br />ID</th>
                                                    <th className="text-white lh-sm" valign="middle">Invoice<br /> Date</th>
                                                    <th className="text-white lh-sm" valign="middle">Invoice<br /> Amount</th>
                                                    <th className="text-white lh-sm" valign="middle">Co-Pay <br />Paid</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentItems.length !== 0 ? (
                                                    currentItems.map((item, i) => {
                                                        return item.copayHistory !== null ? (
                                                            <tr key={i}>
                                                                <td>{item.patientId}</td>
                                                                <td>{item.DateEnrolled && moment(item.DateEnrolled).format('DD/MM/YYYY')}</td>
                                                                <td>{item.dob && moment(item.dob).format('DD/MM/YYYY')}</td>
                                                                <td>{item.gender}</td>
                                                                <td>{item.hcpName}</td>
                                                                <td>{item.hcpSuburb}</td>
                                                                <td>{item.hcpState}</td>
                                                                <td>{item.pharmacyName}</td>
                                                                <td>{item.pharmacySuburb}</td>
                                                                <td>{item.pharmacyState}</td>
                                                                <td>{item.invoiceID}</td>
                                                                <td>{item.invoiceDate && moment(item.invoiceDate).format('DD/MM/YYYY')}</td>
                                                                <td>{item.invoiceAmount == null ? '' : '$' + item.invoiceAmount}</td>
                                                                <td>{item.copayPaid === null ? 'N/A' : item.copayPaid && moment(item.copayPaid).format('DD/MM/YYYY')}</td>
                                                            </tr>
                                                        ) : (
                                                            ""
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td className="text-center" valign="middle" colSpan={14}>
                                                            No records found
                                                        </td>
                                                    </tr>
                                                )}

                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="spacer-2"></div>
                                    <div className='d-flex'>
                                        <nav aria-label="Page navigation example">
                                            <ul className="pagination">
                                                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                    <button className="page-link" onClick={() => paginate(currentPage - 1)}>Previous</button>
                                                </li>
                                                {Array.from({ length: Math.ceil(copayData.length / itemsPerPage) }, (_, index) => (
                                                    <li key={index + 1} className={`page-item ${currentPage === index + 1 ? 'active' : ''}`}>
                                                        <button className="page-link" onClick={() => paginate(index + 1)}>
                                                            {index + 1}
                                                        </button>
                                                    </li>
                                                ))}
                                                <li className={`page-item ${currentPage === Math.ceil(copayData.length / itemsPerPage) ? 'disabled' : ''}`}>
                                                    <button className="page-link" onClick={() => paginate(currentPage + 1)}>Next</button>
                                                </li>
                                            </ul>

                                        </nav>
                                        <div className="ms-auto">
                                            <CSVLink data={copayData} headers={CsvHeaders} filename={"copay Patient Detail.csv"} className='btn btn-primary btn-default'>Export</CSVLink>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="spacer-10"></div>
                            <div className="row">
                                <div className="col-sm-12 text-center">
                                    <Link to="/co-pay-welcome" className="btn btn-primary btn-default">Close</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </main>
            <Footer />
        </>
    )
}

export default CoPayDashboard